import { render, staticRenderFns } from "./KZGReportEdit.vue?vue&type=template&id=0bd967d8&scoped=true"
import script from "./KZGReportEdit.vue?vue&type=script&lang=js"
export * from "./KZGReportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd967d8",
  null
  
)

export default component.exports